import type { DetailPageConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Contacts } from "@/src/gql/graphql";
import { contactDetailTabs } from "../config/contact-detail-tabs";
import { contactDetailActions } from "@/lib/actions/definitions/entities";
import { contactDetailBreadcrumbs } from "../config/contact-detail-breadcrumbs";
import {
  contactTitleTemplate,
  contactDescriptionTemplate,
} from "../config/contact-detail-templates";

// ============================================================================
// CONTACT DETAIL PAGE CONFIGURATION
// ============================================================================

export const ENHANCED_CONTACT_DETAIL_CONFIG: DetailPageConfig<Contacts> = {
  entity: "contacts",
  displayName: "Contact",
  tabs: contactDetailTabs,
  actions: contactDetailActions,
  breadcrumbs: contactDetailBreadcrumbs,
  defaultTab: "details",
  showHeader: true,
  showBreadcrumbs: true,
  showActions: true,
  titleTemplate: contactTitleTemplate,
  descriptionTemplate: contactDescriptionTemplate,
};
